;(function(factory) {
    // conditional factory logic should be placed here.
    if (typeof Lum == 'undefined' || typeof jQuery == 'undefined') {
        var lmnInterval = setInterval(function(){
            if (typeof Lum != 'undefined' && typeof jQuery != 'undefined') {
                clearInterval(lmnInterval);
                factory(jQuery);
            }
        }, 100);
    } else {
        factory(jQuery);
    }
})(function($) {

    /**
     * The module is not loaded by default.
     * @type {Boolean}
     */
    var loaded = false;

    /**
     * Keep the map object instantiated.
     */
    var map;

    /**
     * This are the default options for the autocomplete.
     * Types: Geocode (generic)
     * Restrictions: Country US to display only USA addresses
     * 
     * @type {Object}
     */
    var defaultOptions = {
        types: ['geocode'],
        componentRestrictions: {
            country: "us"
        }
    };

    /**
     * This are the default options for the google Map.
     * 
     * @type {Object}
     */
    var defaultMapOptions = {
        center: {
            lat: -33.8688,
            lng: 151.2195
        },
        zoom: 13
    };

    /**
     * Loads Google Autocomplete
     * @param  {Function} callback The callback to execute once the mask is loaded.
     * @return {Void}            
     */
    function includeGoogle(callback) {
        if (typeof google != 'undefined') {
            if (Lum.checkFunction(callback)) {
                callback();
            }

            return;
        }

        // add &callback=initMap for a callback on load
        // devops account API key: AIzaSyBjlDFLI9tDjvK-sDqqFeRrsMj6NuMDNs4
        var googlePlacesCDN = 'https://maps.googleapis.com/maps/api/js?key=' + script_otpions.gmaps_key + '&libraries=places';

        Lum.loadScriptAsync(googlePlacesCDN, callback);
    }

    /**
     * Given the element id selector it instantiates autocomplete and returns the instance
     *
     * @param  {String} selector   The ID selector #autocomplete
     * @return {Object}  options   The configuration object for the autocomplete
     * @return {Function} callback The callback function on place change
     * 
     * @return {Autocomplete}    The instance of the element
     */
    function initGooglePlaceById(selector, options, callback) {
        // This defers the call if google has not been loaded yet.
        if (typeof google == 'undefined') {
            return setTimeout(function() {
                initGooglePlaceById(selector, options, callback);
            }, 100);
        }

        if (typeof options == 'undefined') {
            options = defaultOptions;
        }

        $(selector).attr('autocomplete', 'off');

        var element = $(selector)[0];
        var autocomplete = new google.maps.places.Autocomplete(element, options);

        if (typeof callback == "function") {
            autocomplete.addListener('place_changed', callback);
        }

        return autocomplete;
    }

    /**
     * Given the main element ID and the other components ID 
     * it binds the autocompleted fields value.
     * 
     * @param  {Object} options  A sample of this object is below.
     * 
     * var options = {
     *     element: "#autocomplete",           // required
     *     citySelector: "#city-element-id",   // optional
     *     stateSelector: "#state-element-id", // optional
     *     zipSelector: "#zip-element-id"      // optional
     * };
     */
    function autocompleteMultiPart(options) {
        if (typeof options == 'undefined') {
            options = {};
        }

        // This defers the call if google has not been loaded yet.
        if (typeof google == 'undefined') {
            return setTimeout(function() {
                autocompleteMultiPart(options);
            }, 100);
        }

        if (typeof options.element == 'undefined') {
            return;
        }

        options = $.extend(options, defaultOptions);

        $(options.element).attr('autocomplete', 'off');

        var el = $(options.element)[0];
        var autocomplete = new google.maps.places.Autocomplete(el, options);

        var _map;

        if (typeof options.mapSelector != 'undefined') {
            if (options.mapSelector == 'default') {
                _map = map;                
            } else {
                _map = new google.maps.Map($(options.mapSelector)[0], defaultMapOptions);
            }
        }

        var _marker;

        autocomplete.addListener('place_changed', function() {
            var place = autocomplete.getPlace();
            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                return;
            }

            if (!place.address_components.length) {
                return;
            }

            var street_address = '';

            place.address_components.forEach(function(element) {
                if (typeof options.zipSelector != 'undefined') {
                    $(options.zipSelector).val('');
                    if (element.types.indexOf("postal_code") != -1 && typeof options.zipSelector != 'undefined') {
                        $(options.zipSelector).val(element.long_name);
                        $(options.zipSelector).trigger('change');
                    }
                }

                if (typeof options.stateSelector != 'undefined') {
                    $(options.stateSelector).val('');
                    if (element.types.indexOf("administrative_area_level_1") != -1 && typeof options.stateSelector != 'undefined') {
                        $(options.stateSelector).val(element.short_name);
                        $(options.stateSelector).trigger('change');
                    }
                }

                if (typeof options.citySelector != 'undefined') {
                    $(options.citySelector).val('');
                    if (element.types.indexOf("sublocality_level_1") != -1 || element.types.indexOf("locality") != -1 ) {
                        $(options.citySelector).val(element.long_name);
                        $(options.citySelector).trigger('change');
                    }
                }

                if (typeof options.countrySelector != 'undefined') {
                    $(options.countrySelector).val('');
                    if (element.types.indexOf("country") != -1 ) {
                        $(options.countrySelector).val(element.short_name);
                        $(options.countrySelector).trigger('change');
                    }
                }

                if (element.types.indexOf("street_number") != -1) {
                    street_address += element.short_name + ' ';
                }

                if (element.types.indexOf("route") != -1) {
                    street_address += element.short_name;
                }
            });

            options.place = place;

            $(options.element).val(street_address);
            $(options.element).trigger('change');

            if (typeof _map != 'undefined') {
                // If the place has a geometry, then present it on a map.
                if (place.geometry.viewport) {
                    _map.fitBounds(place.geometry.viewport);
                } else {
                    _map.setCenter(place.geometry.location);
                    _map.setZoom(17);  // Why 17? Because it looks good.
                }

                _marker = new google.maps.Marker({
                    map: _map,
                    anchorPoint: new google.maps.Point(0, -29)
                });

                _marker.setPosition(place.geometry.location);
                _marker.setVisible(true);
            }
        });

        return autocomplete;
    }

    /**
     * Given an autocomplete object and a callback function it binds them.
     * @param {Autocomplete} autocomplete The instance of the object.
     * @param {Function}     callback     The callback function
     */
    function addCallbackToAutocomplete(autocomplete, callback) {
        autocomplete.removeListener('place_changed');
        autocomplete.addListener('place_changed', callback);
    }

    var initGooglePlaces = function (selector, options) {
        if (typeof selector == 'undefined') {
            selector = '.lumina-autocomplete';
        }

        if (typeof options == 'undefined') {
            options = defaultOptions;
        }

        // Loading has been completed
        if (typeof google != 'undefined') {
            loaded = true;
        }

        if ($(selector).length) {
            $(selector).each(function(element) {
                $(this).attr('autocomplete', 'off');

                var autocomplete = new google.maps.places.Autocomplete(this, options);
            }); 
        }

        initMap();
    };

    var initMap = function (selector, options, callback) {
        // This defers the call if google has not been loaded yet.
        if (typeof google == 'undefined') {
            setTimeout(function() {
                initMap(selector, options, callback);
            }, 100);
            
            return map;
        }

        // prevent memory filling with unliked maps.
        if (typeof map != 'undefined') {
            delete(map);
        }

        if (typeof selector == 'undefined') {
            selector = "#map";
        }

        if (typeof options == 'undefined') {
            options = defaultMapOptions;
        }

        if (!$(selector).length) {
            return;
        }

        var maps = [];

        if ($(selector).length > 1) {
            $(selector).each(function(index, element) {
                map = new google.maps.Map(element, options);
                maps.push(map);

                if (typeof callback != 'undefined') {
                    callback(map)
                }

            });
        } else {
            map = new google.maps.Map($(selector)[0], options);
            if (typeof callback != 'undefined') {
                callback(map)
            }

            maps.push(map);
        }

        return maps;
    };

    var addMarker = function (map, options) {
        // This defers the call if google has not been loaded yet.
        if (typeof google == 'undefined') {
            return setTimeout(function() {
                addMarker(map, options);
            }, 100);
        }

        if (typeof options == 'undefined') {
            options = {};
        }

        var defOptions = $.extend({map: map}, options);

        var marker = new google.maps.Marker(defOptions);

        return marker;
    };

    /**
     * Check to see if google maps has been loaded.
     * @return {Boolean}    True if the load is completed.
     */
    var isLoadComplete = function () {return loaded;};

    /**
     * When map is loaded you can use all the google.something without
     * triggering the error. 
     * 
     * @param  {Function} callback Function to use to initiate map operations.
     */
    var onMapLoaded = function (callback) {
        // This defers the call if google has not been loaded yet.
        if (typeof google == 'undefined') {
            return setTimeout(function() {
                onMapLoaded(callback);
            }, 100);
        }

        if (Lum.checkFunction(callback)) {
            callback();
        }
    };

    /**
     * Keep the file versioned.
     * @return {String}
     */
    var version = function () {
        return '1.0.7';
    };

    window.Lum.Maps = {
        initMap: initMap,
        initGooglePlaces: initGooglePlaces,
        initGooglePlaceById: initGooglePlaceById,
        mapsLoaded: isLoadComplete,
        addCallbackToAutocomplete: addCallbackToAutocomplete,
        autocompleteMultiPart: autocompleteMultiPart,
        addMarker: addMarker,
        version: version,
        onMapLoaded: onMapLoaded
    }

    includeGoogle(initGooglePlaces);
});
